import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance25751un9ltd4f as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.l5v_1 = call;
        this.m5v_1 = responseData.p5j_1;
        this.n5v_1 = responseData.k5j_1;
        this.o5v_1 = responseData.n5j_1;
        this.p5v_1 = responseData.l5j_1;
        this.q5v_1 = responseData.q5j_1;
        var tmp = this;
        var tmp_0 = responseData.o5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.r5v_1 = tmp0_elvis_lhs == null ? Companion_getInstance().c4l_1 : tmp0_elvis_lhs;
        this.s5v_1 = responseData.m5j_1;
      }
      v5i() {
        return this.l5v_1;
      }
      bw() {
        return this.m5v_1;
      }
      e5j() {
        return this.n5v_1;
      }
      f5j() {
        return this.o5v_1;
      }
      g5j() {
        return this.p5v_1;
      }
      h5j() {
        return this.q5v_1;
      }
      d5j() {
        return this.r5v_1;
      }
      v51() {
        return this.s5v_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
